import { IsInt } from 'class-validator';

export class NomenclatureTypeChildRestoreRequest {
    @IsInt()
    public id: number;

    constructor(data?: Partial<NomenclatureTypeChildRestoreRequest>) {
        this.id = data?.id;
    }
}
